export default "__VITE_ASSET__C16V6LiF__"